module.exports = __webpack_public_path__ + "static/media/rupee-indian.9913905d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/rupee/rupee-indian.svg
// module id = 776
// module chunks = 0